var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#acb8c7}.st2{fill:#808a96}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m118.5 49.2 11.3 26.3 33-1.4 4.5-28.6-24.4-14.1",
    className: "st0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.8,
    cy: 102,
    rx: 51.8,
    ry: 55,
    style: {
      fill: "#eee"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ZD7A3s.tif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.1 188.7H94.9c-14.7-8.5-29.4-16.9-44.1-25.4-3.4-2-7.2-3.5-10.1-6.3 8-8.9 16.6-17.2 25.3-25.5 2.2 1.9 4.2 4 6.6 5.7 10 7.3 21.4 9.5 33.6 8.7 19.2-1.3 31.5-12.5 34.2-30.9.5-3.3.2-3.6-3.1-3.8-6.2-.3-12.4-.6-18.6-1-1.4-.1-2 .3-2.1 1.7-.4 3-1.4 5.8-3.5 8.1-4.5 4.7-10.3 5.3-16.1 4-6.4-1.4-9.8-6.1-11.6-12.2 5.3-5.2 10.5-10.4 15.8-15.6 4.6-4.5 8.8-9.3 13.7-13.4.8.8 1.1 1.9 1.3 3 .3 1.4 1 2 2.5 2 6.8.1 13.6.2 20.3.4 2 .1 2.8-.5 2.5-2.8-1.2-7.8-4.8-14.5-9.9-20.4 1.5-.1 2.2-1.3 3.1-2.2 7.6-7.5 15.3-15 22.9-22.5 4.4 1.5 8 4.5 12.1 6.5 5.3 2.6 9.2 6.3 10.7 12.2v80.6c-1.3 5.4-4.8 9-9.6 11.6-8.8 4.8-17.4 9.9-26.1 14.9-13.2 7.4-26.4 15-39.6 22.6",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 157c-5.8-2.5-11.3-5.6-16.3-9.5-3.4-2.7-4.7-6.7-4.7-10.9V61.8c0-5.9 2.5-10.4 7.7-13.4 21.4-12.3 42.8-24.7 64.3-37 5.3-3 10.7-3.2 16-.2 16.2 9.3 32.5 18.6 48.7 28 .4.2.7.7 1.1 1-7.6 7.5-15.2 15-22.9 22.5-.9.9-1.6 2.1-3.1 2.2-6.8-7.2-15.2-11.3-25-12.5-20-2.3-44.5 7.9-49.6 34.9-3 15.9-1.1 30.9 9.1 44.2-8.6 8.3-17.3 16.6-25.3 25.5",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2 111.9c-3.6-9.7-3.2-19.3 1.3-28.6 4.6-9.3 16.4-12 24.3-5.9 1.8 1.4 3.5 3 4.1 5.4-4.9 4.1-9.2 9-13.7 13.4-5.5 5.2-10.7 10.5-16 15.7",
    className: "st2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9 188.7s4.5 3.3 10.2 0",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.025e8748eafd6a34f1cd4f6b50cac6cc.svg";
export { ForwardRef as ReactComponent };